import { imageNames } from "@/src/constants/imageConstants.js";

export const MAILBOX_HEADERS = [
  { label: "Sender Account", key: "email", width: 12 },
];

export const EMAIL_VENDOR_OPTIONS = ["SMTP", "BULK_UPLOAD"];

export const getTrackingOptions = (
  openTrackingEnabled,
  clickTrackingEnabled
) => [
  { type: "open", label: "open", enabled: openTrackingEnabled },
  { type: "click", label: "click", enabled: clickTrackingEnabled },
];

export const SECONDARY_ACTIONS = [
  {
    label: "Edit Mailbox",
    icon: imageNames.EDIT,
  },
  {
    label: "Mark as personal",
    icon: imageNames.STAR_GREY,
  },
  {
    label: "Disconnect",
    confirmRequired: true,
    confirmTitle: "Disconnect Mailbox",
    confirmMessage: "Are you sure you want to disconnect this mailbox?",
    icon: imageNames.DISCONNECT_GREY,
  },
];

export const NAME_TYPE_OPTIONS = [
  {
    value: "combo",
    label: "Random Male & Female names",
  },
  { value: "male", label: "Random Male names only" },
  { value: "female", label: "Random Female names only" },
];

export const CSV_BOX_SHEET_KEYS = {
  development: "pMCuzqKieLOaTUMr4ksCmKu8CPHxYR",
  production: "mjorU2n2Fk4sYePWrAsDv5j2PeeKQB",
};
